export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Electrical technicians and engineers in industrial plants, utilities and electrical maintenance, electrical supervisors, panel builders and advanced electrical engineering students.',
  ],
  [
    'Content depth?',
    'From distribution fundamentals to LV and MV equipment, protection coordination, testing, maintenance and electrical safety.',
  ],
  [
    'International?',
    'Yes. Based on internationally used concepts and terminology; always follow local codes, site procedures and manufacturer instructions.',
  ],
  [
    'Format?',
    'Professional PDF files for study and technical reference, with instant access. It is not software, calculators, editable drawings, arc flash studies or a certified course.',
  ],
  [
    'Does it replace official training?',
    'No. It is study and technical reference material. It does not replace official training, applicable standards, manufacturer manuals, site procedures or a qualified person.',
  ],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
